import React from 'react'

export default class RequireLogin extends React.Component {
  render() {
    if (!window.SERVER_SIDE_RENDERING && !this.props.user) {
      window.location.href = '/'
    }
    return this.props.children
  }
}